import React from 'react';

/**
 * Video 태그 컴포넌트
 */

interface IVideoProps {
  // videoRef: RefObject<HTMLVideoElement>;
  onClick(e: any): void;
  // onCanPlay(e: React.SyntheticEvent<HTMLVideoElement, Event>): void;
  // onPlaying(e: React.SyntheticEvent<HTMLVideoElement, Event>): void;
  // onPause(e: React.SyntheticEvent<HTMLVideoElement, Event>): void;
  // onTimeUpdate(e: React.SyntheticEvent<HTMLVideoElement, Event>): void;
  // onSeeked(): void;
  // onEnded(): void;
}

const Video: React.FC<IVideoProps> = ({
  // videoRef,
  onClick,
  // onCanPlay,
  // onPlaying,
  // onPause,
  // onTimeUpdate,
  // onSeeked,
  // onEnded,
}) => {
  return <div id='videoLayer' onClick={onClick}></div>;
};

export default Video;
